export const mainUrl = {
  auth: "https://auth.hotel.westerops.com/",
  booking: "https://booking.hotel.westerops.com/",
};
